import React, { useState } from 'react';
import './CommonStyles.css';
import './Products.css';
import BusinessSettings from './BusinessSettings';
import BusinessLocations from './BusinessLocations';
import InvoiceSettings from './InvoiceSettings';
import BarcodeSettings from './BarcodeSettings';
import ReceiptPrinters from './ReceiptPrinters';
import TaxRates from './TaxRates';
import PackageSubscription from './PackageSubscription';

// Tab definitions for Settings
const SETTINGS_TABS = [
  { id: 'business-settings', label: 'Business Settings', icon: 'fa fa-cogs' },
  { id: 'business-locations', label: 'Business Locations', icon: 'fa fa-map-marker' },
  { id: 'invoice-settings', label: 'Invoice Settings', icon: 'fa fa-file-text' },
  { id: 'barcode-settings', label: 'Barcode Settings', icon: 'fa fa-barcode' },
  { id: 'receipt-printers', label: 'Receipt Printers', icon: 'fa fa-print' },
  { id: 'tax-rates', label: 'Tax Rates', icon: 'fa fa-percent' },
  { id: 'package-subscription', label: 'Package Subscription', icon: 'fa fa-box' }
];

const Settings = () => {
  const [activeTab, setActiveTab] = useState('business-settings');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'business-settings': return <BusinessSettings />;
      case 'business-locations': return <BusinessLocations />;
      case 'invoice-settings': return <InvoiceSettings />;
      case 'barcode-settings': return <BarcodeSettings />;
      case 'receipt-printers': return <ReceiptPrinters />;
      case 'tax-rates': return <TaxRates />;
      case 'package-subscription': return <PackageSubscription />;
      default: return <BusinessSettings />;
    }
  };

  return (
    <div className="products-container">

      <div className="main-card">

        {/* Horizontal Navigation Tabs */}
        <div className="product-tabs" style={{ flexWrap: 'wrap', borderBottom: '1px solid var(--etpos-border)' }}>
          {SETTINGS_TABS.map(tab => (
            <div
              key={tab.id}
              className={`product-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <i className={tab.icon} /> {tab.label}
            </div>
          ))}
        </div>

        {/* Tab Content Area */}
        <div style={{ minHeight: '400px', background: 'var(--etpos-bg)', padding: '1rem' }}>
          {renderTabContent()}
        </div>

      </div>
    </div>
  );
};

export default Settings;
